import { useMutation, useQuery } from '@apollo/client'
import { useTour } from '@tecsinapse-org/portal-menu-kit'
import gql from 'graphql-tag'
import { useCallback } from 'react'
import type {
  OnboardingByIdQuery,
  OnboardingByIdQueryVariables,
  SetOnboardingIdMutation,
  SetOnboardingIdMutationVariables
} from '@/core/types/graphql'

const QUERY_ONBOARDING_BY_ID = gql`
  query OnboardingByID($id: ID!) {
    currentUserOnboardingIsSeen(id: $id)
  }
`

const MUTATION_SET_ONBOARDING_ID = gql`
  mutation SetOnboardingID($id: ID!) {
    setCurrentUserOnboardingSeen(id: $id)
  }
`

export const useOnboarding = (id: string) => {
  const { data, loading } = useQuery<
    OnboardingByIdQuery,
    OnboardingByIdQueryVariables
  >(QUERY_ONBOARDING_BY_ID, {
    variables: { id }
  })
  const [setSeen] = useMutation<
    SetOnboardingIdMutation,
    SetOnboardingIdMutationVariables
  >(MUTATION_SET_ONBOARDING_ID, { refetchQueries: [QUERY_ONBOARDING_BY_ID] })
  const { setSteps, setIsOpen, setCurrentStep } = useTour()

  const setOpen = useCallback(
    (delay = 1000) => {
      setTimeout(() => setIsOpen(true), delay)
    },
    [setIsOpen]
  )

  const save = useCallback(async () => {
    await setSeen({ variables: { id } })
  }, [setSeen, id])

  return {
    setOpen,
    setSeen,
    currentUserOnboardingIsSeen: data?.currentUserOnboardingIsSeen,
    setSteps,
    loading,
    save,
    setCurrentStep
  }
}
